export default __webpack_public_path__ + "static/search-bg-8ee98090387e07627c76fc9988657959.png";